import request from '../utils/request.js'

/**
 * 购物车订单详情接口
 * **/
export function getOrderInfo(data) {
  return request({
    url: '/rest/cart/order/detail/' + data,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/cart-order-detail.js